
import './App.css';
import Privacy from './Components/privacy';
import Header from './Components/MainFooter';

function App() {
  return (
    <>
      <Privacy />
      
    </>
  );
}

export default App;
